"use strict";
/**
 * @module "ethpm/storage/ipfs"
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("util");
const Unixfs = require('ipfs-unixfs');
const { DAGNode } = require('ipld-dag-pb');
function hash(content) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = Buffer.from(content, 'ascii');
        const unixFs = new Unixfs('file', data);
        const dagNode = yield util_1.promisify(DAGNode.create)(unixFs.marshal());
        return dagNode.toJSON().multihash;
    });
}
exports.default = hash;
